export interface Code {
    title: string
    md?: string | (() => Promise<string | typeof import("*.md")>) // 通常是通过异步require引入一个markdown文件。（利用了markdown-loader包，实际上require markdown文件得到的就是一段html字符串，因此理论上，这里填写markdown字符串也是没有任何问题的）
    href?: string
    abstract?: string
    img?: string
    tag?: { content: string, color: string }
}

function state() {
    const code: Code[] = [
        {
            title: "YOLOv13",
            abstract: "A real-time object detector that uses hypergraph-enhanced adaptive visual perception to model high-order correlations across multi-scale features.",
            href: "https://github.com/iMoonLab/yolov13",
            tag: { content: "RESEARCH CODE", color: "secondary" },
            img: require("../assets/research area/yolo13_show.png")
        },
        {
            title: "Hyper-RAG",
            abstract: "A hypergraph-driven retrieval-augmented generation framework that grounds LLM responses in higher-order domain knowledge and helps mitigate hallucinations.",
            href: "https://github.com/iMoonLab/Hyper-RAG",
            tag: { content: "RESEARCH CODE", color: "secondary" },
            img: require("../assets/research area/hyperrag.svg")
        },
        {
            title: "Hyper-Extract",
            abstract: "An LLM-powered framework for extracting and evolving strongly typed knowledge abstracts, from simple collections to graphs and hypergraphs.",
            href: "https://github.com/yifanfeng97/Hyper-Extract",
            tag: { content: "TOOLKIT", color: "primary" },
            img: require("../assets/research area/hyper_extract.jpg")
        },
        {
            title: "THU-DeepHypergraph",
            abstract: "A pytorch library for hypergraph learning for medical image, 3D and other hypergraph applications.",
            href: "https://github.com/iMoonLab/THU-DeepHypergraph",
            tag: { content: "TOOLKIT", color: "primary" },
            img: require("../assets/code/dhg.png")
        },
        {
            title: "THU-HyperG",
            abstract: "A python toolbox for hypergraph learning, where several hypergraph generation methods and learning methods on hypergraph as well as some useful utilities are provided.",
            href: "https://github.com/iMoonLab/THU-HyperG",
            tag: { content: "TOOLKIT", color: "primary" },
            img: require("../assets/research area/hypergraph_logo_purple.png")
        },
        {
            title: "DHGNN",
            abstract: `Source code for IJCAI19 paper: "Dynamic Hypergraph Neural Networks"`,
            href: "https://github.com/iMoonLab/DHGNN",
            tag: { content: "RESEARCH CODE", color: "secondary" },
            img: require("../assets/code/dhgnn.png")
        },
        {
            title: "MeshNet",
            abstract: `Source code for "MeshNet: Mesh Neural Network for 3D Shape Representation" (AAAI 2019)`,
            href: "https://github.com/iMoonLab/MeshNet",
            tag: { content: "RESEARCH CODE", color: "secondary" },
            img: require("../assets/code/meshnet.png")
        },
        {
            title: "PVRNet",
            abstract: `Source code for "PVRNet: Point-View Relation Neural Network for 3D Shape Recognition" (AAAI 2019)"`,
            href: "https://github.com/iMoonLab/PVRNet",
            tag: { content: "RESEARCH CODE", color: "secondary" },
            img: require("../assets/code/pvrnet.png")
        },
        {
            title: "HGNN",
            abstract: `Source code for "Hypergraph Neural Networks" (AAAI 2019)`,
            href: "https://github.com/iMoonLab/HGNN",
            tag: { content: "RESEARCH CODE", color: "secondary" },
            img: require("../assets/code/hgnn.png")
        },
    ]
    const code_zh: Code[] = [
        {
            title: "YOLOv13",
            abstract: "面向实时目标检测的超图增强视觉感知模型，通过建模多尺度特征间的高阶关联提升复杂场景感知能力。",
            href: "https://github.com/iMoonLab/yolov13",
            tag: { content: "RESEARCH CODE", color: "secondary" },
            img: require("../assets/research area/yolo13_show.png")
        },
        {
            title: "Hyper-RAG",
            abstract: "超图驱动的检索增强生成框架，利用高阶领域知识为大语言模型回答提供依据，并缓解事实幻觉。",
            href: "https://github.com/iMoonLab/Hyper-RAG",
            tag: { content: "RESEARCH CODE", color: "secondary" },
            img: require("../assets/research area/hyperrag.svg")
        },
        {
            title: "Hyper-Extract",
            abstract: "由大语言模型驱动的知识抽取与演化框架，可将非结构化文档转化为从集合、图到超图的强类型知识抽象。",
            href: "https://github.com/yifanfeng97/Hyper-Extract",
            tag: { content: "TOOLKIT", color: "primary" },
            img: require("../assets/research area/hyper_extract.jpg")
        },
        {
            title: "THU-DeepHypergraph",
            abstract: "用于医学图像、3D和其他超图应用的超图学习的pytorch库。",
            href: "https://github.com/iMoonLab/THU-DeepHypergraph",
            tag: { content: "TOOLKIT", color: "primary" },
            img: require("../assets/code/dhg.png")
        },
        {
            title: "THU-HyperG",
            abstract: "一个用于超图学习的python工具箱，其中提供了几种超图生成方法和超图学习方法以及一些有用的实用程序。",
            href: "https://github.com/iMoonLab/THU-HyperG",
            tag: { content: "TOOLKIT", color: "primary" },
            img: require("../assets/research area/hypergraph_logo_purple.png")
        },
        {
            title: "DHGNN",
            abstract: `IJCAI19 论文: "Dynamic Hypergraph Neural Networks"的源代码`,
            href: "https://github.com/iMoonLab/DHGNN",
            tag: { content: "RESEARCH CODE", color: "secondary" },
            img: require("../assets/code/dhgnn.png")
        },
        {
            title: "MeshNet",
            abstract: `"MeshNet: Mesh Neural Network for 3D Shape Representation" (AAAI 2019)的源代码`,
            href: "https://github.com/iMoonLab/MeshNet",
            tag: { content: "RESEARCH CODE", color: "secondary" },
            img: require("../assets/code/meshnet.png")
        },
        {
            title: "PVRNet",
            abstract: `"PVRNet: Point-View Relation Neural Network for 3D Shape Recognition" (AAAI 2019)"的源代码`,
            href: "https://github.com/iMoonLab/PVRNet",
            tag: { content: "RESEARCH CODE", color: "secondary" },
            img: require("../assets/code/pvrnet.png")
        },
        {
            title: "HGNN",
            abstract: ` "Hypergraph Neural Networks" (AAAI 2019)的源代码`,
            href: "https://github.com/iMoonLab/HGNN",
            tag: { content: "RESEARCH CODE", color: "secondary" },
            img: require("../assets/code/hgnn.png")
        },
    ]
    return { zh: code_zh, en: code }
}

export default state()
